import { Box, Typography, getTokenCssVar } from '@vp/swan';
import { __ } from '@99designs/i18n';

export type ChatCompletionLinkProps = {
    onReview: () => void;
};

/**
 * Persistent "your brief is ready" reminder shown above the composer once the
 * customer has continued chatting past a completed brief.
 */
export function ChatCompletionLink({ onReview }: ChatCompletionLinkProps) {
    return (
        <Box
            style={{
                maxWidth: '768px',
                margin: '0 auto',
                padding: `0 ${getTokenCssVar('SwanSemSpace5')} ${getTokenCssVar('SwanSemSpace3')}`,
                textAlign: 'center',
            }}
        >
            <Typography fontSkin="body-standard">
                {__('Your brief is ready')}{' '}
                {/* Raw <button>, not swan's <Button skin="link">, since this sits inline in a
                    sentence and swan's link skin still applies button box-model/padding. */}
                <button
                    type="button"
                    onClick={onReview}
                    style={{
                        background: 'none',
                        border: 'none',
                        padding: 0,
                        cursor: 'pointer',
                        textDecoration: 'underline',
                        color: 'inherit',
                        font: 'inherit',
                    }}
                >
                    {__('Review and checkout', {
                        _context:
                            'Inline link shown above the composer once the customer continues chatting past a completed brief, taking them to review and check out.',
                    })}
                </button>
            </Typography>
        </Box>
    );
}
